import React from 'react';
import _ from 'lodash';
import { IExperience } from 'pages/About/About.types';
import ExperienceCard from 'pages/About/ExperienceCard';
import { useTranslation } from 'react-i18next';

import { Box, Paper, Typography } from '@mui/material';

interface ExperienceProps {
  bio: string;
  experience: IExperience[];
  education: IExperience[];
}

const Experience: React.FunctionComponent<ExperienceProps> = ({
  bio,
  experience,
  education,
}) => {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <Box sx={styles.bio}>
        {bio.split('\n').map((paragraph) => (
          <Typography key={_.uniqueId()} sx={{ py: 1 }} align='justify'>
            {paragraph}
          </Typography>
        ))}
      </Box>
      <Paper sx={styles.experience}>
        <Typography variant='h6'>{t('about.experience.title')}</Typography>
        {experience.map((experience) => (
          <ExperienceCard key={experience.id} experience={experience} />
        ))}
      </Paper>
      <Paper sx={styles.education}>
        <Typography variant='h6'>{t('about.education.title')}</Typography>
        {education.map((experience) => (
          <ExperienceCard key={experience.id} experience={experience} />
        ))}
      </Paper>
    </React.Fragment>
  );
};

const styles = {
  bio: { px: 3, pb: 1, my: 1 },
  experience: { px: 3, pb: 1, pt: 2, my: 2 },
  education: { px: 3, pb: 1, pt: 2, my: 1 },
};

export default Experience;
